import classNames from 'classnames';
import { func, string } from 'prop-types';

import ButtonClean from '~/components/ButtonClean';

import styles from './Title.module.scss';

export default function Title({ hrefClassName, text, textClassName, onClick }) {
  return onClick ? (
    <ButtonClean
      className={hrefClassName}
      onClick={onClick}
    >
      {text}
    </ButtonClean>
  ) : (
    <span className={classNames(styles.text, textClassName)}>{text}</span>
  );
}

Title.propTypes = {
  hrefClassName: string,
  text: string,
  textClassName: string,
  onClick: func,
};
